import Statuses from './Statuses.main';

export default Statuses;
